import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "menu flex column" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "logo mt-40" }, null, -1)
const _hoisted_3 = { class: "menu flex-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "pl-20" }, "使用者管理", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "pl-20" }, "公司介紹管理", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "pl-20" }, "公司聯絡資訊", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "pl-20" }, "營業項目", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "pl-20" }, "工程實績", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "pl-20" }, "SEO 設定", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "pl-20" }, "聯絡紀錄", -1)
const _hoisted_11 = { class: "logout p-20 flex column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["safari-wrap flex align-stretch", {'login': _ctx.isLogin}]),
    id: "app"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_menu, {
          router: "",
          "default-active": _ctx.menu
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_menu_item, { index: "/users" }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, { index: "/company" }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, { index: "/contact-info" }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, { index: "/business" }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, { index: "/project" }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, { index: "/seo" }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, { index: "/contacts" }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["default-active"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.logout
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('general.logout')), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    (_ctx.ready)
      ? (_openBlock(), _createBlock(_component_router_view, {
          key: 0,
          class: "page-content"
        }))
      : _createCommentVNode("", true)
  ], 2))
}